/* eslint-disable no-magic-numbers */
import React, { useRef, useState } from 'react';
import './ElementGlyphModal.styles.css';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import {
  elementGlyphStateSelector,
  elementMetaStateSelector,
  elementSubmapStateSelector,
} from '@/redux/modal/modal.selector';
import {
  ElementGlyphForm,
  ElementGlyphFormHandles,
} from '@/components/FunctionalArea/Modal/ElementGlyphModal/ElementGlyphForm.component';
import {
  ElementSubmapForm,
  ElementSubmapFormHandles,
} from '@/components/FunctionalArea/Modal/ElementGlyphModal/ElementSubmapForm.component';
import { ElementMetaDataForm } from '@/components/FunctionalArea/Modal/ElementGlyphModal/ElementMetaDataForm.component';

export const ElementGlyphModal: React.FC = () => {
  const elementGlyphState = useAppSelector(elementGlyphStateSelector);
  const elementSubmapState = useAppSelector(elementSubmapStateSelector);
  const elementMetaState = useAppSelector(elementMetaStateSelector);

  if (!elementGlyphState || !elementSubmapState || !elementMetaState) {
    throw new Error('Invalid element');
  }

  const [selectedGlyph, setSelectedGlyph] = useState<number | null>(elementGlyphState.glyph);
  const [file, setFile] = useState<File | null>(null);
  const glyphFormRef = useRef<ElementGlyphFormHandles>(null);

  const [selectedMapModel, setSelectedMapModel] = useState<number | null>(
    elementSubmapState.submap,
  );
  const submapFormRef = useRef<ElementSubmapFormHandles>(null);

  const [immediateLink, setImmediateLink] = useState<string>(elementMetaState.immediateLink || '');

  return (
    <div className="relative flex w-[800px] flex-col gap-3 border border-t-[#E1E0E6] bg-white p-[24px]">
      <ElementSubmapForm
        ref={submapFormRef}
        selectedMapModel={selectedMapModel}
        setSelectedMapModel={setSelectedMapModel}
      />
      <hr />
      <ElementMetaDataForm immediateLink={immediateLink} setImmediateLink={setImmediateLink} />
      <hr />
      <ElementGlyphForm
        ref={glyphFormRef}
        file={file}
        selectedGlyph={selectedGlyph}
        setFile={setFile}
        setSelectedGlyph={setSelectedGlyph}
      />
    </div>
  );
};
